import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input-left" }
const _hoisted_2 = ["placeholder", "value", "disabled"]
const _hoisted_3 = ["placeholder", "value", "disabled"]
const _hoisted_4 = { class: "input-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-small", { shake: _ctx.shake, error: _ctx.error, success: _ctx.success, edit: _ctx.state === 'EDITING' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "left", {}, undefined, true)
    ]),
    (!_ctx.mask)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "text",
          class: "input-field",
          placeholder: _ctx.placeholder,
          value: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args))),
          onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
          onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.focusOut && _ctx.focusOut(...args))),
          onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args))),
          disabled: _ctx.disabled,
          ref: "inputElement"
        }, null, 40, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.mask)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "text",
          class: "input-field",
          placeholder: _ctx.placeholder,
          value: _ctx.modelValue,
          onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args))),
          onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
          onFocusout: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.focusOut && _ctx.focusOut(...args))),
          onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args))),
          disabled: _ctx.disabled,
          ref: "inputElement"
        }, null, 40, _hoisted_3)), [
          [_directive_mask, _ctx.mask]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "right", {}, undefined, true)
    ])
  ], 2))
}